/**
 * @description Check if the URL contains the `selectedJobSlug` query parameter.
 * - `url`: *string* - The URL to check.
 */
export const checkSelectedJobSlug = (url: string) => {
  // If the URL is relative, combine it with the current origin to make it absolute
  const absoluteUrl = url.startsWith('http') ? url : `${window.location.origin}${url}`;

  // Create a new URL object
  const { searchParams } = new URL(absoluteUrl);

  // Return the value of the 'selectedJobSlug' parameter, or null if it's not found
  return searchParams.get('selectedJobSlug');
};
